import { resolution } from "../../config/ui/resolutionConfig";

export default {
  slidesToScroll: 1,
  slidesToShow: 7,
  infinite: false,
  height: resolution.carousel.height.mainMenu,
  ...resolution?.mainMenu
};
